// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"31ac0ce7","703":"513007af","760":"9eb8391c","787":"408dc359"}[chunkId] + ".chunk.js";
};